import { Skeleton, Typography } from "@mui/material";
import { useGetPoolTotalQuery } from "Api/Queries/Settlements/useGetPoolTotalQuery";
import type {
  CurrencyCode,
  LoyaltyPointType,
  Region,
} from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";
import { formatCurrency } from "Utils/CurrencyUtils";

const RESOURCES = Resources.Admin.SettlementPoolBoosts;

type Props = {
  region: Region;
  loyaltyPointType: LoyaltyPointType;
  currencyCode: CurrencyCode;
};

export const PoolTotalDisplay = ({
  region,
  loyaltyPointType,
  currencyCode,
}: Props) => {
  const { t } = useResource();
  const { data, isLoading, isError } = useGetPoolTotalQuery(
    region,
    loyaltyPointType,
  );

  return (
    <div>
      <Typography variant="body2" color="text.secondary">
        {t(RESOURCES.CurrentPoolTotal, { currency: currencyCode })}
      </Typography>
      {isLoading ? (
        <Skeleton width={120} />
      ) : isError ? (
        <Typography fontWeight={600} color="error">
          {t(RESOURCES.PoolTotalLoadError)}
        </Typography>
      ) : (
        <Typography fontWeight={600}>
          {formatCurrency({
            amount: data?.poolTotal.value ?? 0,
            currencyCode: data?.poolTotal.currencyCode ?? currencyCode,
          })}
        </Typography>
      )}
    </div>
  );
};
